// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1UJf4","description":"PatientConsentPreview_description__1gHxU"};